





































import {Vue, Component, Model, Prop, Watch} from 'vue-property-decorator';
import { debounce } from 'typescript-debounce-decorator';
import CompanyDTO from "@/dto/company/CompanyDTO";
import CompanyFilterDTO from "@/dto/company/CompanyFilterDTO";
import CompanyService from "@/services/CompanyService";
import {processError} from "@/utils/ComponentUtils";

@Component({})
export default class SimpleCompanySearch extends Vue {

  @Model('change', {type: CompanyDTO, default: null})
  private selectedCompany!: CompanyDTO | null;

  @Prop({default: "companies"})
  private name!: string

  @Prop({default: false})
  private required!: boolean;

  @Prop({ default: false })
  private wideMenu!: boolean;

  private filter = new CompanyFilterDTO({pageSize: 8});

  private companies: Array<CompanyDTO> = [];

  private showList = false;

  private dropUp = false;

  mounted(){
    if(this.selectedCompany){
      this.filter.searchQuery = this.selectedCompany.name + ' ' + this.selectedCompany.ein + ' ' + this.selectedCompany.email;
    }
  }

  @debounce(200)
  private search(){
    CompanyService.getByFilter(this.filter).then(
        ok => {
          this.companies = ok.data.data;
          this.showList = true;

          this.$nextTick(() => {
            this.updateDropDownPosition();
          });
        },
        err => processError(err, this)
    )
  }

  selectCompany(c: CompanyDTO){
    this.showList = false;
    this.filter.searchQuery = c.name + ' ' + c.ein + ' ' + c.email;
    this.$emit('change', c);
  }

  @Watch("selectedCompany")
  watchCompany(_new: CompanyDTO | null, old: CompanyDTO | null){
    if(_new == null){
      this.filter.searchQuery = null;
    }
  }

  private updateDropDownPosition() {
    const inputEl = this.$el.querySelector('input');
    const autocompleteEl = this.$refs.autocomplete as HTMLElement;
    if(!inputEl || !autocompleteEl) return;

    const inputRect = inputEl.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const spaceBelow = windowHeight - inputRect.bottom - 15;
    const spaceAbove = inputRect.top - 15;

    if (spaceBelow < 180 && spaceAbove > spaceBelow) {
      this.dropUp = true;
      autocompleteEl.style.maxHeight = `${spaceAbove}px`;
    } else {
      this.dropUp = false;
      autocompleteEl.style.maxHeight = `${Math.max(120, spaceBelow)}px`;
    }
  }
}
